import { PickerService } from 'app/_services/picker.service';
import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import {
    ComfortBidDtoWithConfig,
    ComfortBidWizardCtx,
    mgoAngularWizard
} from '../custom';

class ComfortBidWizardSpecifyComponentCtrl implements ng.IController {
    wizardCtrl: mgoAngularWizard.Wizard<ComfortBidWizardCtx>;

    constructor(
        private pickerService: PickerService,
        private utilService: UtilService
    ) {}

    $onInit(): void {
        if (
            !this.wizardCtrl.context.data ||
            !this.wizardCtrl.context.data.length
        ) {
            this.addComfortBid(true);
        }
    }

    public addComfortBid(initialBid = false): void {
        if (
            this.wizardCtrl.context.data == null ||
            !this.wizardCtrl.context.data.length
        ) {
            this.wizardCtrl.context.data = [];
        }
        const addedComfortBid: ComfortBidDtoWithConfig =
            this.wizardCtrl.context.data[
                this.wizardCtrl.context.data.push(
                    {} as ComfortBidDtoWithConfig
                ) - 1
            ];
        addedComfortBid.orderRuntime = this.createInitialOrderRuntime();
        addedComfortBid.limitBids = [];
    }

    public removeBid(indexOfComfortBid: number): void {
        this.wizardCtrl.context.data.splice(indexOfComfortBid, 1);
    }

    private createInitialOrderRuntime(): DateInterval {
        const dayAheadRuntime: DateInterval =
            this.utilService.getRunTimeSuggestion('DAY');
        return {
            start: this.pickerService.asCet(
                dayAheadRuntime.start as Date,
                this.utilService.setTimeToStartOfGasDay(dayAheadRuntime.start)
            ),
            end: this.pickerService.asCet(
                dayAheadRuntime.end as Date,
                this.utilService.setTimeToEndOfDay(dayAheadRuntime.end)
            )
        };
    }

    public submit(form: ng.IFormController): void {
        if (!form.$valid) {
            return;
        }
        this.wizardCtrl.next();
    }
}

angular.module('app').component('pkpComfortBidWizardSpecify', {
    controller: ComfortBidWizardSpecifyComponentCtrl,
    template: require('app/comfort-bid/comfort-bid-wizard-specify.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
